import * as types from "./mutation-types";
import * as backends from "./backends";
import { ledgerHDPaths } from "./constants";
import { convertMesssages } from "./lib/tendermint";

const setBackend = ({ commit }, name) => {
  commit(types.SET_ACTIVE_BACKEND_NAME, name);
};

const importBackend = async ({ commit, state }, createArgs) => {
  try {
    const activeBackend = await backends[state.activeBackendName].create(
      createArgs
    );
    commit(types.SET_VALID_BACKEND, true);
    commit(types.SET_ACTIVE_BACKEND, activeBackend);
  } catch (err) {
    commit(types.SET_VALID_BACKEND, err.message);
    commit(types.SET_ACTIVE_BACKEND, {});
  }
};

const cleanUpBackend = ({ commit }) => {
  commit(types.CLEAN_UP_BACKEND);
};

const getLedgerAppName = ({}, { coinName, hdPath }) => {
  const ret = ledgerHDPaths[coinName]?.find((item) =>
    arePathsSimilar(
      convertPathStringToArray(hdPath),
      convertPathStringToArray(item.path)
    )
  );
  return ret?.app ?? coinName;
};

const convertPathStringToArray = (path = "") =>
  path.replace(/'|m\//g, "").split("/").map(Number);

const arePathsSimilar = (path1, path2) => {
  if (!path1 || !path2) return false;
  return path1[0] === path2[0] && path1[1] === path2[1];
};

const convertTendermintMsgs = ({}, msgs) => {
  return convertMesssages(msgs);
};

export {
  setBackend,
  importBackend,
  cleanUpBackend,
  getLedgerAppName,
  convertTendermintMsgs,
};
